import type { AnalysisViewTypeEnum } from 'venn-api';
import { isReport } from './studioUtils';

export const DEFAULT_STUDIO_VIEW_NAME = 'Saved Studio View';
export const DEFAULT_STUDIO_REPORT_NAME = 'Saved Report';

export const getDefaultStudioViewName = (date: string, analysisViewType?: AnalysisViewTypeEnum) =>
  `${analysisViewType && isReport(analysisViewType) ? DEFAULT_STUDIO_REPORT_NAME : DEFAULT_STUDIO_VIEW_NAME}: ${date}`;
